<template>
  <div class="mt-8 px-6">
    <h2 class="text-xl font-semibold leading-tight text-gray-700 my-3">
      Add New Post
    </h2>
    <div class="p-6 bg-white rounded-md shadow-md">
      <form @submit.prevent="actionCreatePost" enctype="multipart/form-data">
        <div class="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
          <div class="">
            <label class="text-gray-700" for="post_title">Post Title</label>
            <input
              v-model="formDataPost.title"
              class="bg-gray-50 border border-gray-300 text-gray-900 my-2 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              type="text"
              id="post_title"
              minlength="3"
              maxlength="20"
              autocomplete="off"
              required
            />
          </div>
          <!-- Post Image -->
          <div>
            <label class="text-gray-700" for="file_input">Upload image</label>
            <input
              class="form-control my-2 block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              accept="image/png, image/jpg, image/gif, image/jpeg"
              id="file_input"
              type="file"
              ref="file"
              @change="selectFile"
              required
            />
          </div>
          <div class="">
            <label class="text-gray-700" for="categories">Categories</label>
            <input
              v-model="formDataPost.categories"
              class="bg-gray-50 border border-gray-300 text-gray-900 my-2 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              type="text"
              id="categories"
              autocomplete="off"
            />
          </div>
          <div class="">
            <label class="text-gray-700" for="tags">Tags</label>
            <input
              v-model="formDataPost.tags"
              class="bg-gray-50 border border-gray-300 text-gray-900 my-2 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 focus:outline-none block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              type="text"
              id="tags"
              autocomplete="off"
            />
          </div>
          <div class="col-span-2">
            <label class="text-gray-700" for="description_post"
              >Description</label
            >
            <textarea
              v-model="formDataPost.description"
              minlength="15"
              maxlength="400"
              id="description_post"
              rows="4"
              class="block p-2.5 w-full my-2 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Leave a description..."
              required
            ></textarea>
          </div>
          <div class="sm:col-span-2">
            <label
              for="content_post"
              class="text-gray-700"
              >Content</label
            >
            <textarea class="block p-2.5 w-full my-2 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" name="" id="content_post" cols="30" rows="7" v-model="formDataPost.content"></textarea>
            <!-- <editor
              api-key=""
              v-model="formDataPost.content"
              id="content_post"
              :init="{
                height: 500,
                menubar: true,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                   alignleft aligncenter alignright alignjustify | \
                   bullist numlist outdent indent | removeformat | help',
              }"
            /> -->
          </div>
        </div>

        <div class="flex justify-end mt-4">
          <button
            class="px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700"
            :disabled="isSending"
          >
            <fa-icon
              icon="rotate"
              class="text-xl"
              :spin="true"
              v-if="isSending"
            />
            <span v-else>Save</span>
          </button>
        </div>
      </form>
    </div>
  </div>
  <!-- List post -->
  <div class="mt-8 px-6">
    <h2 class="text-xl font-semibold leading-tight text-gray-700 my-3">
      List Posts
    </h2>
    <div class="flex flex-col mt-3 sm:flex-row">
      <div class="flex">
        <div class="relative">
          <select
            class="block w-full h-full rounded-l px-4 py-2 pr-8 leading-tight text-gray-700 bg-white border-t border-b border-r border-gray-400 rounded-r appearance-none sm:rounded-r-none sm:border-r-0 focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500"
            v-model="select"
            @change="searchedByStatus"
          >
            <option value="all">All</option>
            <option value="1">In Stock</option>
            <option value="0">Out Stock</option>
          </select>
        </div>
      </div>

      <div class="relative block mt-2 sm:mt-0">
        <span class="absolute inset-y-0 left-0 flex items-center pl-2">
          <svg viewBox="0 0 24 24" class="w-4 h-4 text-gray-500 fill-current">
            <path
              d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z"
            />
          </svg>
        </span>

        <input
          placeholder="Search"
          class="block w-full py-2 pl-8 pr-6 text-sm text-gray-700 placeholder-gray-400 bg-white border border-b border-gray-400 rounded-l rounded-r appearance-none sm:rounded-l-none focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none"
          v-model="search"
          @input="searchedByName"
        />
      </div>
    </div>

    <div class="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
      <div class="inline-block min-w-full overflow-hidden rounded-lg shadow">
        <table class="min-w-full">
          <thead>
            <tr>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Title
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Description
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Author
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Categories
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Tags
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Create At
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Update At
              </th>
              <th
                class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody class="bg-white">
            <tr v-for="(postItem, index) in arrayPosts[page]" :key="index">
              <td class="px-6 py-4 border-b border-gray-200 whitespace-nowrap">
                <!-- Post Item -->
                <div class="flex items-center">
                  <div
                    class="flex justify-center w-10 h-10 rounded-full overflow-hidden"
                  >
                    <img
                      class="h-10 w-10 object-cover"
                      :src="postItem.imgUrl"
                      alt="Product Image"
                    />
                  </div>
                  <div class="ml-4">
                    <div class="text-sm font-medium leading-5 text-gray-900">
                      {{ postItem.title }}
                    </div>
                  </div>
                </div>
              </td>

              <td class="px-6 py-4 border-b border-gray-200 whitespace-nowrap">
                <!-- start on -->
                <div class="text-sm leading-5 text-gray-500">
                  {{ postItem.description }}
                </div>
              </td>

              <!-- Author -->
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap"
              >
                {{ postItem.author }}
              </td>

              <!-- Categories -->
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap"
              >
                {{ postItem.categories }}
              </td>

              <!-- Tags -->
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap"
              >
                {{ postItem.tags }}
              </td>

              <!-- Create At -->
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap"
              >
                {{ postItem.createAt }}
              </td>

              <!-- Update At -->
              <td
                class="px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap"
              >
                {{ postItem.updateAt }}
              </td>

              <td
                class="px-6 py-4 text-sm font-medium leading-5 text-right border-b border-gray-200 whitespace-nowrap space-x-3"
              >
                <router-link
                  :to="{ name: 'SinglePost', params: { id: postItem.id } }"
                  class="text-indigo-600 hover:text-indigo-900"
                >
                  Edit
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination -->
        <div
          class="flex flex-col items-center px-5 py-5 bg-white border-t xs:flex-row xs:justify-between"
        >
          <span class="text-xs text-gray-900 xs:text-sm"
            >There is {{ posts.length }} Products.
          </span>

          <div class="inline-flex mt-2 xs:mt-0 space-x-2">
            <button
              class="px-4 py-2 text-sm rounded font-semibold text-gray-800 bg-gray-300 hover:bg-gray-400"
              v-for="i in arrayPosts.length"
              :key="i"
              @click="changePage(i)"
            >
              {{ i }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- success alert -->
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
    >
      <div
        class="px-4 py-20 overflow-x-auto absolute top-1 rounded-md whitespace-nowrap"
        v-if="isSuccess"
      >
        <div
          class="inline-flex w-full overflow-hidden bg-white rounded-lg shadow-md"
        >
          <div class="flex items-center justify-center w-12 bg-green-500">
            <svg
              class="w-6 h-6 text-white fill-current"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"
              />
            </svg>
          </div>

          <div class="px-4 py-2 -mx-3">
            <div class="mx-3">
              <span class="font-semibold text-green-500">Success</span>
              <p class="text-sm text-gray-600">Your product was created!</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- error alert -->
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__fadeIn"
      leave-active-class="animate__animated animate__fadeOut"
    >
      <div
        class="px-4 py-20 overflow-x-auto absolute top-1 rounded-md whitespace-nowrap"
        v-if="isError"
      >
        <div
          class="inline-flex w-full overflow-hidden bg-white rounded-lg shadow-md"
        >
          <div class="flex items-center justify-center w-12 bg-red-500">
            <svg
              class="w-6 h-6 text-white fill-current"
              viewBox="0 0 40 40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 3.36667C10.8167 3.36667 3.3667 10.8167 3.3667 20C3.3667 29.1833 10.8167 36.6333 20 36.6333C29.1834 36.6333 36.6334 29.1833 36.6334 20C36.6334 10.8167 29.1834 3.36667 20 3.36667ZM19.1334 33.3333V22.9H13.3334L21.6667 6.66667V17.1H27.25L19.1334 33.3333Z"
              />
            </svg>
          </div>

          <div class="px-4 py-2 -mx-3">
            <div class="mx-3">
              <span class="font-semibold text-red-500">Error</span>
              <p class="text-base text-gray-800">
                Can't get target upload source info
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { dateFormat, showFive } from "../../assets/Methods";
import Editor from "@tinymce/tinymce-vue";

export default {
  data() {
    return {
      baseUrl: this.$store.state.basePostUrl,
      // to get data value from FORM INPUT
      formDataPost: {
        title: "",
        description: "",
        content: "",
        author: "",
        categories: "",
        tags: "",
      },
      // to get data post form API - array
      posts: [],
      arrayPosts: [],
      DBArrayPosts: [],
      isSending: false,
      isSuccess: false,
      isError: false,
      page: 0,
    };
  },
  components: {
    // editor: Editor,
  },
  methods: {
    // Call api create post from Store (VueX)
    async actionCreatePost() {
      this.isSending = true;
      try {
        const res = await this.$store.dispatch("createPost", this.formDataPost);
        if (res === 201) {
          this.isSuccess = true;
          this.formDataPost = {
            types: "",
            name: "",
            price: "",
            description: "",
            categories: "",
            file: "",
            quantity: "",
          };
          console.log("Log: call API form UI: " + res);
          this.isSending = false;
          await this.setData();
          setTimeout(() => {
            this.isSuccess = false;
          }, 3000);
          return;
        }
        console.log("FILE: " + res);
        this.isError = true;
        this.isSending = false;

        setTimeout(() => {
          this.isSuccess = false;
        }, 3000);
        return;
      } catch (err) {
        console.log(err);
      }
      this.isSending = false;
    },
    // Call api get all posts from Store (Vue X)
    async getPosts() {
      try {
        const res = await this.$store.dispatch("getPosts");
        res.data.map((post) => {
          post.createAt = dateFormat(post.createAt);
          post.updateAt = dateFormat(post.updateAt);
          post.imgUrl = this.baseUrl + post.imgUrl;
        });
        return res.data.reverse();
      } catch (err) {
        console.log(err);
      }
    },
    // set data
    async setData() {
      this.posts = await this.getPosts();
      this.arrayPosts = showFive(this.posts);
    },
    // Select file
    selectFile() {
      this.formDataPost.file = this.$refs.file.files[0];
    },
    // Pagination
    changePage(i) {
      this.page = i - 1;
    },
  },
  async created() {
    await this.setData();
    this.DBArrayProducts = this.arrayProducts;
  },
  async mounted() {},
};
</script>
ß